import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const LOGO_URL = 'https://www.sdtlab.it/assets/images/SDT_logo_2025_nobg.png';

const Footer = () => {
  const { t } = useLanguage();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const navbarHeight = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: elementPosition - navbarHeight, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Info */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img
                src={LOGO_URL}
                alt="SDTLab Logo"
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Smart Digital Technology LAB s.r.l.
            </p>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">{t.contact.subtitle}</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3 text-gray-400">
                <MapPin className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" />
                <div className="text-sm">
                  Via Guglielmo Marconi 141/143<br />
                  65126 Pescara (PE)
                </div>
              </div>
              <div className="flex items-center gap-3 text-gray-400">
                <Phone className="w-5 h-5 text-amber-500 flex-shrink-0" />
                <div className="text-sm">
                  <a href="tel:+39335400541" className="hover:text-amber-400 transition-colors">+39 335 400541</a><br />
                  <a href="tel:+393335345411" className="hover:text-amber-400 transition-colors">+39 333 534 5411</a>
                </div>
              </div>
              <div className="flex items-center gap-3 text-gray-400">
                <Mail className="w-5 h-5 text-amber-500 flex-shrink-0" />
                <a href="mailto:info@sdtlab.it" className="text-sm hover:text-amber-400 transition-colors">
                  info@sdtlab.it
                </a>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Navigazione</h4>
            <div className="space-y-2">
              <button onClick={() => scrollToSection('home')} className="block text-gray-400 hover:text-amber-400 transition-colors text-sm">
                {t.nav.home}
              </button>
              <button onClick={() => scrollToSection('products')} className="block text-gray-400 hover:text-amber-400 transition-colors text-sm">
                {t.nav.products}
              </button>
              <button onClick={() => scrollToSection('services')} className="block text-gray-400 hover:text-amber-400 transition-colors text-sm">
                {t.nav.services}
              </button>
              <button onClick={() => scrollToSection('company')} className="block text-gray-400 hover:text-amber-400 transition-colors text-sm">
                {t.nav.company}
              </button>
              <button onClick={() => scrollToSection('contact')} className="block text-gray-400 hover:text-amber-400 transition-colors text-sm">
                {t.nav.contact}
              </button>
            </div>
          </div>

          {/* Legal */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Legal</h4>
            <div className="space-y-2">
              <Link to="/privacy" className="block text-gray-400 hover:text-amber-400 transition-colors text-sm">
                {t.nav.privacy}
              </Link>
              <Link to="/cookies" className="block text-gray-400 hover:text-amber-400 transition-colors text-sm">
                {t.nav.cookies}
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Smart Digital Technology LAB. {t.footer.rights}.
            </p>
            <p className="text-gray-500 text-sm">
              {t.footer.vat}: 02404780682
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;